import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import {
  Button,
  Dimmer,
  Grid,
  Step,
  Popup,
  Loader,
  Modal,
} from "semantic-ui-react";
import { eComFeatures, facilities } from "../../constants/appConstants";
const numeral = require("numeral");
import jobbing from "../../assets/images/pages/jobbing.png";
import settings from "../../assets/images/pages/settings.png";
import findBOAPod from "../../assets/images/pages/find-boapod.png";
import myAssets from "../../assets/images/pages/my-assets.png";
import products from "../../assets/images/pages/products.png";
import orderHistory from "../../assets/images/pages/order-history.png";
import myResources from "../../assets/images/pages/my-resources.png";
import boaHIS from "../../assets/images/pages/boa-his.png";
import inventory from "../../assets/images/pages/inventory.png";
import { useWindowSize } from "../../utils/utils";
import { HISpostData } from "../../containers/BOAhis/hisAPIprovider";
import jobManagement from "../../assets/images/pages/jobManagement.png";
import quoting from "../../assets/images/pages/quoting.png";
import myCustomers from "../../assets/images/pages/my-customers.png";
import nonBOAItems from "../../assets/images/pages/non-boa-items.png";
import sampleFeature from "../../assets/images/sample-feature.png";
import { apiGetVersionHistoryDetails } from "../MyResources/myResources.api";
import Markdown from "react-markdown";
import DotsPagination from "../../components/DotsPagination";
import newIcon from "../../assets/images/icons/new_icon.png";
import changedIcon from "../../assets/images/icons/changed_icon.png";
import fixedIcon from "../../assets/images/icons/fixed_icon.png";

const featureImages = [
  { name: "Job Management", image: jobManagement },
  { name: "Find BOApod", image: findBOAPod },
  { name: "My Assets", image: myAssets },
  { name: "My Customers", image: myCustomers },
  { name: "Products", image: products },
  { name: "My Orders", image: orderHistory },
  { name: "My Resources", image: myResources },
  { name: "Hydraulic Information System", image: boaHIS },
  { name: "Inventory Management", image: inventory },
  { name: "Settings", image: settings },
  { name: "Quoting", image: quoting },
  { name: "Jobbing", image: jobbing },
  { name: "Non-BOA Items", image: nonBOAItems },
];

const EnterpriseHomeComponent = ({ goToPage }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [HISusers, setHISusers] = useState(false);
  const [isJobbingOpen, setIsJobbingOpen] = useState(false);
  const [currentWidth, setCurrentWidth] = useState(1300);

  // New Feature
  const [isLoading, setIsLoading] = useState(false);
  const [isFeaturePopupOpen, setIsFeaturePopupOpen] = useState(
    localStorage.getItem("showPopUp") === "true" ? true : false
  );
  const [secondPopupViewed, setSecondPopupViewed] = useState(false);
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [versionHistory, setVersionHistory] = useState({});
  const [versionDetails, setVersionDetails] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 1;
  const totalItems = versionDetails.length;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentVersionDetails = versionDetails.slice(startIndex, endIndex);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const ref = useRef();
  const buttonRef = useRef(null);
  const size = useWindowSize();

  useEffect(() => {
    if (size) {
      setCurrentWidth(window.innerWidth);
    }
  }, [size]);

  useEffect(() => {
    if (isFeaturePopupOpen) {
      const delayDebounceFn = setTimeout(() => {
        getVersionHistoryDetails();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [isFeaturePopupOpen]);

  const getVersionHistoryDetails = async () => {
    setIsLoading(true);
    try {
      const result = await apiGetVersionHistoryDetails();
      if (result) {
        setVersionHistory(result);
        setVersionDetails(JSON.parse(result.markdownText));
        console.log(JSON.parse(result.markdownText));
        setIsLoading(false);
      }
    } catch (error) {
      showErrorToast("Failed to get resources. Please try again.");
      setIsLoading(false);
    }
  };

  const getImageByFeature = (name) => {
    if (
      name === "Job Management" &&
      localStorage.getItem("isBoahubPremium") !== "true"
    ) {
      name = "Jobbing";
    }

    const feature = featureImages.find((item) => item?.name === name);
    if (feature) return feature.image;
  };

  const checkHISpermission = async () => {
    const userEmail = localStorage.getItem("user");
    const response = await HISpostData("/his/users", { email: userEmail });
    if (response.ok) {
      setHISusers(true);
      const isAdmin = await response.json();
      localStorage.setItem("HISisAdmin", isAdmin);
    }
  };

  useEffect(() => {
    checkHISpermission();
    const screenWidth = localStorage.getItem("screenWidth");
    if (screenWidth) {
      const width = Number(screenWidth);
      if (width !== 0) {
        if (width <= 850) {
          if (window.location.pathname.includes("/home")) {
            setIsMobile(true);
            setIsLoaded(true);
          }
        } else {
          if (window.location.pathname.includes("/home")) {
            setIsMobile(false);
            setIsLoaded(true);
          }
        }
      }
    }
  }, []);

  const EcomFeatures = () => {
    useEffect(() => {
      if (
        localStorage.getItem("showPopUp") === "true" &&
        !isFeaturePopupOpen &&
        !secondPopupViewed
      ) {
        // Delay opening to ensure DOM is ready
        const timer = setTimeout(() => {
          setSecondPopupViewed(false);
          buttonRef?.current?.click();
        }, 100); // 100ms delay is often enough
        return () => clearTimeout(timer);
      }
    }, [isFeaturePopupOpen]);
    const hasJobbing = localStorage.getItem("accessJobbing");
    const accountTypeData = localStorage.getItem("accountType");
    const accountType = Number(accountTypeData);
    const userTypeData = localStorage.getItem("userType");
    const userType = Number(userTypeData);
    const hasBoahubFindPod = localStorage.getItem("boahubFindPod");
    const isBoahubPremium = localStorage.getItem("isBoahubPremium");

    // Predetermine how many features to show and calculate size of tiles
    let featuresCount = eComFeatures.length;
    eComFeatures.map((feature) => {
      if (feature.title === "Job Management" && hasJobbing !== "true") {
        featuresCount -= 1;
      }
      if (feature.title === "My Orders" && accountType === 3) {
        featuresCount -= 1;
      }
      if (feature.title === "Products" && accountType === 3) {
        featuresCount -= 1;
      }
      if (feature.title === "Find BOApod" && hasBoahubFindPod !== "true") {
        featuresCount -= 1;
      }
      if (
        feature.title === "Inventory Management" &&
        isBoahubPremium !== "true"
      ) {
        featuresCount -= 1;
      }
      if (
        (feature.title === "My Customers" && userType === 4) ||
        (feature.title === "My Customers" &&
          (accountType === 2 || accountType === 3))
      ) {
        featuresCount -= 1;
      }
      if (feature.title === "Non-BOA Items" && isBoahubPremium !== "true") {
        featuresCount -= 1;
      }
    });
    const gridWidthSize = 16;
    const featureTileSize = Math.floor(gridWidthSize / featuresCount);

    return accountType === 0 ? (
      <div style={{ height: 216, padding: 60 }}>
        <Loader active className="workaround" size="large" inline="centered" />
      </div>
    ) : (
      <div>
        <Grid
          centered
          style={{
            paddingTop: 80,
            height: "100%",
            paddingLeft: !hasJobbing && !isMobile ? 260 : isMobile ? 0 : 200,
            paddingRight: isMobile ? 0 : 200,
            paddingBottom: 20,
          }}
        >
          {_.map(eComFeatures, (feature, key) => {
            const { title, page, image, active } = feature;

            // Checking for features to hide
            if (title === "Job Management" && hasJobbing !== "true") {
              return null;
            }
            if (title === "My Orders" && accountType === 3) {
              return null;
            }
            if (title === "Products" && accountType === 3) {
              return null;
            }
            if (title === "Find BOApod" && hasBoahubFindPod !== "true") {
              return null;
            }
            if (title === "Hydraulic Information System" && !HISusers) {
              return null;
            }
            if (
              title === "Inventory Management" &&
              isBoahubPremium !== "true"
            ) {
              return null;
            }
            if (
              (title === "My Customers" && userType === 4) ||
              (title === "My Customers" &&
                (accountType === 2 || accountType === 3))
            ) {
              return null;
            }
            if (title === "Non-BOA Items" && isBoahubPremium !== "true") {
              return null;
            }
            return (
              <Grid.Column
                width={
                  isMobile
                    ? 8
                    : accountType === 1
                    ? 4
                    : featureTileSize > 2
                    ? featureTileSize
                    : 3
                }
                key={key}
                style={{ textAlign: "center" }}
              >
                {title === "My Resources" &&
                localStorage.getItem("showPopUp") === "true" &&
                !isFeaturePopupOpen &&
                !secondPopupViewed ? (
                  <Step.Group
                    style={{
                      width: "100%",
                      boxShadow:
                        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                      border: "1.5px solid rgb(102, 204, 35)",
                    }}
                  >
                    <Popup
                      wide
                      className="feature-popup"
                      content="Hello"
                      position="top center"
                      on="click"
                      trigger={
                        <button
                          ref={buttonRef}
                          style={{ border: "none", width: "100%" }}
                        >
                          <Step
                            onClick={() => {
                              setSecondPopupViewed(true);
                              window.localStorage.setItem("showPopUp", false);
                            }}
                          >
                            <img
                              src={getImageByFeature(title)}
                              style={{
                                height: isMobile ? 55 : "70px",
                                width: "auto",
                              }}
                            />
                          </Step>
                        </button>
                      }
                    >
                      <div style={{ padding: 10 }}>
                        <Button
                          circular
                          style={{
                            backgroundColor: "#fff",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.4)",
                            position: "absolute",
                            right: -15,
                            top: -12,
                            cursor: "pointer",
                            padding: "4px 9px 7px 9px",
                          }}
                          onClick={() => {
                            setSecondPopupViewed(true);
                            window.localStorage.setItem("showPopUp", false);
                          }}
                        >
                          x
                        </Button>
                        <span>
                          {`You can see release details under`}
                          <br />
                          {`My Resources > Version History.`}
                        </span>
                      </div>
                    </Popup>
                  </Step.Group>
                ) : active ? (
                  <Step.Group
                    style={{
                      width: "100%",
                      boxShadow:
                        "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 10px 0 rgba(0, 0, 0, 0.19)",
                      border: "1.5px solid rgb(102, 204, 35)",
                    }}
                  >
                    <Step
                      onClick={(e) => {
                        if (
                          title === "Job Management" &&
                          localStorage.getItem("isBoahubPremium") === "true"
                        ) {
                          setTimeout(() => {
                            setIsJobbingOpen(true);
                          }, 300);
                        } else {
                          e.preventDefault();
                          if (e.ctrlKey) {
                            e.stopPropagation();
                            window.open(`/${page}`);
                            return;
                          }
                          goToPage(page);
                        }
                      }}
                    >
                      <img
                        src={getImageByFeature(title)}
                        style={{
                          height: isMobile ? 55 : "70px",
                          width: "auto",
                        }}
                      />
                    </Step>
                  </Step.Group>
                ) : (
                  <Popup
                    content="Coming Soon!"
                    position="top center"
                    trigger={
                      <Step.Group
                        style={{
                          width: "100%",
                          boxShadow:
                            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                          border: "1.5px solid rgb(102, 204, 35)",
                        }}
                      >
                        <Step
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          <img
                            src={getImageByFeature(title)}
                            style={{
                              height: isMobile ? 55 : "70px",
                              width: "auto",
                            }}
                          />
                        </Step>
                      </Step.Group>
                    }
                  />
                )}
                <div
                  style={{
                    position: "absolute",
                    bottom: -5,
                    width: "100%",
                    paddingRight: 32,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <span
                    style={{
                      fontSize: 20,
                      color: "rgb(102, 204, 35)",
                    }}
                  >
                    {title === "Job Management" &&
                    localStorage.getItem("isBoahubPremium") !== "true"
                      ? "Jobbing"
                      : title}
                  </span>
                </div>
              </Grid.Column>
            );
          })}
        </Grid>
      </div>
    );
  };

  return (
    <>
      <Modal
        onClose={() => setIsJobbingOpen(false)}
        closeIcon
        size="tiny"
        closeOnDimmerClick={true}
        open={isJobbingOpen}
        style={{ marginTop: -150 }}
      >
        <Modal.Header>JOB MANAGEMENT</Modal.Header>
        <Modal.Content>
          <Grid style={{ padding: 30 }}>
            {localStorage.getItem("isBoahubPremium") !== "true" && (
              <Grid.Column width={4}></Grid.Column>
            )}
            {localStorage.getItem("isBoahubPremium") === "true" && (
              <Grid.Column
                width={8}
                className="card-body"
                style={{ textAlign: "center", position: "relative" }}
              >
                <Step.Group
                  style={{
                    width: "100%",
                    boxShadow:
                      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                    border: "1.5px solid rgb(102, 204, 35)",
                  }}
                >
                  <Step
                    onClick={(e) => {
                      e.preventDefault();
                      if (e.ctrlKey) {
                        e.stopPropagation();
                        window.open(`/quoting`);
                        return;
                      }
                      goToPage("quoting");
                    }}
                  >
                    <img
                      src={getImageByFeature("Quoting")}
                      style={{
                        height: isMobile ? 55 : "70px",
                        width: "auto",
                      }}
                    />
                  </Step>
                </Step.Group>
                <div
                  style={{
                    position: "absolute",
                    bottom: -5,
                    width: "100%",
                    paddingRight: 32,
                  }}
                >
                  <span style={{ fontSize: 20, color: "rgb(102, 204, 35)" }}>
                    Quoting
                  </span>
                </div>
              </Grid.Column>
            )}
            <Grid.Column
              width={8}
              className="card-body"
              style={{ textAlign: "center", position: "relative" }}
            >
              <Step.Group
                style={{
                  width: "100%",
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                  border: "1.5px solid rgb(102, 204, 35)",
                }}
              >
                <Step
                  onClick={(e) => {
                    e.preventDefault();
                    if (e.ctrlKey) {
                      e.stopPropagation();
                      window.open(`/jobbing`);
                      return;
                    }
                    goToPage("jobbing");
                  }}
                >
                  <img
                    src={getImageByFeature("Jobbing")}
                    style={{
                      height: isMobile ? 55 : "70px",
                      width: "auto",
                    }}
                  />
                </Step>
              </Step.Group>
              <div
                style={{
                  position: "absolute",
                  bottom: -5,
                  width: "100%",
                  paddingRight: 32,
                }}
              >
                <span style={{ fontSize: 20, color: "rgb(102, 204, 35)" }}>
                  Jobbing
                </span>
              </div>
            </Grid.Column>
            {localStorage.getItem("isBoahubPremium") !== "true" && (
              <Grid.Column width={4}></Grid.Column>
            )}
          </Grid>
        </Modal.Content>
      </Modal>
      <Modal
        onClose={() => setIsFeaturePopupOpen(false)}
        closeIcon
        className="feature-modal"
        closeOnDimmerClick={false}
        open={isFeaturePopupOpen}
      >
        <Modal.Header>New BOAhub Features</Modal.Header>
        <Modal.Content>
          {isLoading || !versionHistory.id ? (
            <Dimmer active inverted>
              <Loader size="large"></Loader>
            </Dimmer>
          ) : null}
          {versionHistory.id ? (
            <div
              style={{ height: 510, overflowX: "hidden", overflowY: "scroll" }}
            >
              <Grid style={{ padding: 20 }}>
                <Grid.Column width={16} style={{ paddingTop: 0 }}>
                  <div>
                    <span
                      style={{
                        fontSize: 26,
                        fontWeight: "bolder",
                        color: "#66cc23",
                      }}
                    >
                      {versionHistory.description}
                    </span>
                  </div>
                  <div style={{ paddingBottom: 20 }}>
                    <span
                      style={{
                        fontSize: 16,
                        color: "#AFABAB",
                      }}
                    >
                      {versionHistory.versionNumber
                        ? `v${versionHistory.versionNumber}`
                        : ""}
                    </span>
                  </div>
                  <div>
                    {currentVersionDetails.map((data, index) => (
                      <div style={{ paddingBottom: 15 }} key={index}>
                        <h3
                          style={{
                            borderBottom: "1px solid #d1d9e0b3",
                            paddingTop: 5,
                            paddingBottom: ".3em",
                            color: "#66CC23",
                          }}
                        >
                          <img
                            src={
                              data.title === "New"
                                ? newIcon
                                : data.title === "Changed"
                                ? changedIcon
                                : fixedIcon
                            }
                            style={{
                              marginTop: -4.5,
                              width: 25,
                              height: "auto",
                              marginRight: 8,
                            }}
                          />
                          {data.title}
                        </h3>
                        <Markdown
                          components={{
                            img: ({ node, ...props }) => (
                              <img
                                {...props}
                                style={{
                                  maxWidth: "50%",
                                  height: "auto",
                                  display: "block",
                                }}
                                alt={props.alt}
                              />
                            ),
                          }}
                        >
                          {data.content}
                        </Markdown>
                      </div>
                    ))}
                  </div>
                </Grid.Column>
              </Grid>
            </div>
          ) : (
            <div style={{ height: 300 }}></div>
          )}
          <div style={{ marginLeft: "auto", marginRight: "auto" }}>
            {isLoading ? null : (
              <DotsPagination
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </Modal.Content>
      </Modal>
      <Grid className="enterprise-home">
        <Grid.Column
          width={16}
          className="card-section"
          style={{
            paddingLeft: isMobile ? 0 : "1rem",
            paddingRight: isMobile ? 0 : "1rem",
          }}
        >
          {isLoaded ? <EcomFeatures /> : null}
        </Grid.Column>
      </Grid>
    </>
  );
};

EnterpriseHomeComponent.propTypes = {
  discountStatistics: PropTypes.object,
  goToPage: PropTypes.func,
  totalSavings: PropTypes.object,
  isFacility: PropTypes.bool,
  showAdvanceSavingsDetails: PropTypes.bool,
  account: PropTypes.object,
};
export default EnterpriseHomeComponent;
